import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import {
  Box,
  Button,
  Form,
  FormSpy,
  TimeRangePicker,
  WeekPicker,
  addDays,
  subtractDays
} from 'groundkeeper-component-library';

export interface TimeTableFilterFormValues {
  week: Date;
  timespan?: {
    start: string;
    end: string;
  };
}

export default function TimeTableFilterForm(props: {
  handleSubmit: (values: TimeTableFilterFormValues) => void;
  initialValues: TimeTableFilterFormValues;
}) {
  const intl = useIntl();

  return (
    <Form
      onSubmit={props.handleSubmit}
      initialValues={props.initialValues}
      disableScrollToError
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} data-testid="timetable-filter-form">
          <FormSpy
            subscription={{ values: true, dirty: true }}
            onChange={s => {
              if (s.dirty) handleSubmit();
            }}
          />
          <Box display="flex" gap={2} flexWrap="wrap">
            <Box display="flex" alignItems="flex-end" flexWrap="wrap">
              <WeekPicker
                id="week"
                label={intl.formatMessage({
                  id: 'week',
                  defaultMessage: 'Week'
                })}
                disablePastWarning
              />
              <FormSpy subscription={{ values: true }}>
                {({ values }) => (
                  <Box mb={0.5}>
                    {/* @ts-ignore: no-typescript-component */}
                    <Button
                      aria-label={intl.formatMessage({
                        id: 'show_previous_week_in_booking_plan',
                        defaultMessage: 'Show previous week in booking plan'
                      })}
                      icon
                      onClick={() => {
                        props.handleSubmit({
                          ...values,
                          week: subtractDays(values.week, 7)
                        });
                      }}
                    >
                      arrow-left
                    </Button>
                    {/* @ts-ignore: no-typescript-component */}
                    <Button
                      aria-label={intl.formatMessage({
                        id: 'show_next_week_in_booking_plan',
                        defaultMessage: 'Show next week in booking plan'
                      })}
                      icon
                      onClick={() =>
                        props.handleSubmit({
                          ...values,
                          week: addDays(values.week, 7)
                        })
                      }
                    >
                      arrow-right
                    </Button>
                  </Box>
                )}
              </FormSpy>
            </Box>
            <TimeRangePicker
              id="timespan"
              label={intl.formatMessage({
                id: 'hours_visible_start_end',
                defaultMessage: 'Display from/to'
              })}
            />
          </Box>
        </form>
      )}
    />
  );
}

TimeTableFilterForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    week: PropTypes.instanceOf(Date),
    timespan: PropTypes.shape({
      start: PropTypes.string,
      end: PropTypes.string
    })
  })
};
